export default __webpack_public_path__ + "static/media/content.54afe86e.png";